import { batch } from 'editor/src/store/batchedSubscribeEnhancer';
import { removeConditionFromConditionAction } from 'editor/src/store/design/slice';
import type { ThunkDispatch } from 'editor/src/store/hooks';

import updateHiddenElementsOperation from './updateHiddenElementsOperation';

const removeConditionFromConditionOperation =
  (spreadIndex: number, conditionId: string, parent: { conditionId: string; optionId: string }) =>
  (dispatch: ThunkDispatch) => {
    batch(() => {
      dispatch(
        removeConditionFromConditionAction({
          spreadIndex,
          conditionId,
          parent,
        }),
      );
      // The condition's own spread, not the viewer's: a design-scoped picklist
      // (showOnAllSpreads) is edited from pages that do not store it.
      dispatch(updateHiddenElementsOperation(spreadIndex));
    });
  };

export default removeConditionFromConditionOperation;
